<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
  >
    <path d="M6 0.5C9.31371 0.5 12 3.18629 12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5C0 3.18629 2.68629 0.5 6 0.5ZM6 1.5C3.23858 1.5 1 3.73858 1 6.5C1 9.26142 3.23858 11.5 6 11.5C8.76142 11.5 11 9.26142 11 6.5C11 3.73858 8.76142 1.5 6 1.5ZM5.24953 7.54242L8.12028 4.66398C8.31528 4.46846 8.63186 4.46803 8.82738 4.66304C9.00118 4.83637 9.02083 5.10577 8.88609 5.30082L8.82833 5.37014L5.60403 8.60308C5.43053 8.77704 5.16082 8.79654 4.96576 8.66146L4.89645 8.60355L3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645C3.32001 5.97288 3.58944 5.9536 3.78431 6.08859L3.85355 6.14645L5.24953 7.54242L8.12028 4.66398L5.24953 7.54242Z" />
  </svg>
</template>
